import React, { useEffect, useMemo, useRef, useState } from "react";
import PropTypes from "prop-types";

import { useOnScreen } from "../hooks/useOnScreen";
import { isValidHexColor } from "../utils/utils";

import "../styles/components/Odometer.scss";

const Odometer = ({
    value,
    includeDollar = false,
    color = "#7200a0",
    includePlus = false,
}) => {
    const [counterState, setCounter] = useState(0);
    const odometerRef = useRef();
    const onScreen = useOnScreen(odometerRef);
    const hexColor = useMemo(() => {
        if (isValidHexColor(color)) {
            return color;
        }

        return "#7200a0";
    }, [color]);

    useEffect(
        timer => {
            if (onScreen) {
                clearInterval();
                timer = setInterval(() => {
                    if (counterState >= value) {
                        clearInterval(timer);
                        return;
                    }
                    setCounter(prev =>
                        Math.min(
                            value,
                            prev +
                                Math.ceil(value / 2000) +
                                Math.floor(Math.random() * 100)
                        )
                    );
                }, 1);
                return () => clearInterval(timer);
            }
        },
        [onScreen, counterState, value]
    );

    return (
        <span
            style={{ color: hexColor }}
            className="odometer rounded"
            ref={odometerRef}
        >
            {includeDollar && "$"}
            {counterState.toLocaleString()}
            {includePlus && "+"}
        </span>
    );
};

Odometer.propTypes = {
    value: PropTypes.number.isRequired,
    includeDollar: PropTypes.bool,
    color: PropTypes.string,
    includePlus: PropTypes.bool,
};

export default Odometer;
